'use client';

import { IDictionary } from '@/dictionaries/types';
import React, { ReactNode, createContext, useContext } from 'react';

const DictsContext = createContext<IDictionary | undefined>(undefined);

export const useTranslation = () => {
  const context = useContext(DictsContext);
  if (!context) {
    throw new Error('useDicts must be used within a DictsProvider');
  }
  return context;
};

export const DictionaryProvider: React.FC<{
  dicts: IDictionary;
  children: ReactNode;
}> = ({ dicts, children }) => {
  return (
    <DictsContext.Provider value={{ ...dicts }}>
      {children}
    </DictsContext.Provider>
  );
};
